// extracted by mini-css-extract-plugin
export default {"Text":"Text_Text__5mm2b","TextError":"Text_TextError__DZNMG","ErrorMessage":"Text_ErrorMessage__0EaXk"};